
import { Box, Grid, styled, Typography, Button, } from "@mui/material"
import { motion } from "motion/react"
import ReservationModal from "../ReservationModal/ReservationModal";
import { useState } from "react";
const HeaderContainer = styled(Box)(({ theme }) => ({
    position: 'relative',
    '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.76)',
        zIndex: 0,
        transition: "opacity 0.2s ease-in",
    },
    backgroundImage: "url(/header.jpeg)",
    backgroundAttachment: "fixed, scroll",
    backgroundSize: "contain",
    height: "65vh",
    WebkitBackgroundSize: "cover",
    backgroundPosition: "center",
    WebkitBackgroundPosition: "cover",
    [theme.breakpoints.down("md")]: {
        padding: "1rem",
        backgroundAttachment: "scroll"
    },
}));



function Header() {
    const [openModal, setOpenModal] = useState(false)
    const handleClick = () => {
        setOpenModal(true)
    }
    const handleClose = () => {
        setOpenModal(false)
    }

    return (
        <>
            <ReservationModal openVar={openModal} onClose={handleClose} ></ReservationModal>
            <Grid container spacing={1}>
                <Grid item xs={12} md={12}>
                    <HeaderContainer>
                    
                        <Grid container sx={{
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            p: 5,
                            zIndex: 99
                        }}>
                            <Grid item xs={12} md={8} sx={{
                                zIndex: 99,
                            }}>
                                <motion.div
                                    initial={{ opacity: 0, x: 100 }}
                                    animate={{ opacity: 1, x: 0 }}
                                >
                                    <Typography variant="h1" component="h1" sx={{
                                        fontWeight: "bold",
                                        color: "white",
                                    }}>RSrent</Typography>
                                    <Typography variant="body2" color={"white"}>Postaráme se o <Box component={"span"} fontWeight={600} color={"secondary.main"}>spolehlivý</Box> a jednoduchý přenos</Typography>

                                </motion.div>
                                <motion.div
                                    initial={{ opacity: 0, y: 100 }}
                                    animate={{ opacity: 1, y: 0 }}
                                >
                                    <Box sx={{
                                        mt: 2
                                    }}>
                                        <Button size="large" color="secondary" variant="contained" onClick={handleClick}>
                                            <Typography variant="h6" fontWeight={700} color={"white"}>  Nezávazně poptat</Typography>

                                        </Button>

                                    </Box>
                                </motion.div>
                            </Grid>
                        </Grid>
                    </HeaderContainer>
                </Grid>
            </Grid>
        </>
    )
}

export default Header